import AVdxbApplicationCompleteSign from './index.vue';

AVdxbApplicationCompleteSign.install = app => {
  app.component(AVdxbApplicationCompleteSign.name, AVdxbApplicationCompleteSign);
};

export default AVdxbApplicationCompleteSign;
